import { render, staticRenderFns } from "./ReceiptCreate.vue?vue&type=template&id=6fcd9c4c&"
import script from "./ReceiptCreate.vue?vue&type=script&lang=js&"
export * from "./ReceiptCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports